export const initialStateNews = {menuSel:"News",
                                contentSel:"Stocks"}